import React from "react";

import AttributesTable from "./AttributesTable";
import ComponentsTable from "./ComponentsTable";
import IdeasTable from "./IdeasTable";
import ProjectsGrid from "./ProjectsGrid";
import TabsHeader from "./TabsHeader";

const Tabs = ({
  activeTab,
  setActiveTab,
  tabs,

  rowsIdeas,
  ideasPicked,
  handlePickedIdea,
  handlePickedIdeasAll,
  selectedAll,
  handleSortChangeIdeas,
  sortIdeas,

  rowsAttributes,
  attributesPicked,
  handlePickedAttribute,
  selectedAllAttributes,
  handlePickedAllAttributes,
  sortAttributes,
  handleSortChangeAttributes,

  rowsComponents,
  componentsPicked,
  projects,
  projectsPicked,
  handlePickedProject,
  handlePickedComponent,
  handlePickedAllComponents,
  selectedAllComponents,
  handleSortChangeComponents,
  sortComponents,
  userStatus,
  userId,
  getTrash,
  userFeatures,
}) => {
  return (
    <>
      <TabsHeader tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />

      {activeTab === 0 && (
        <ProjectsGrid
          getTrash={getTrash}
          projects={projects}
          userStatus={userStatus}
          userId={userId}
          userFeatures={userFeatures}
          handlePickedProject={handlePickedProject}
          projectsPicked={projectsPicked}
        />
      )}

      {activeTab === 1 && (
        <ComponentsTable
          rows={rowsComponents}
          componentsPicked={componentsPicked}
          handlePickedComponent={handlePickedComponent}
          handlePickedAllComponents={handlePickedAllComponents}
          selectedAll={selectedAllComponents}
          // handleSortChange={handleSortChangeComponents}
          // sort={sortComponents}
        />
      )}

      {activeTab === 2 && (
        <AttributesTable
          rows={rowsAttributes}
          attributesPicked={attributesPicked}
          handlePickedAttribute={handlePickedAttribute}
          handlePickedAllAttributes={handlePickedAllAttributes}
          selectedAll={selectedAllAttributes}
          handleSortChange={handleSortChangeAttributes}
          sort={sortAttributes}
        />
      )}

      {activeTab === 3 && (
        <IdeasTable
          rows={rowsIdeas}
          ideasPicked={ideasPicked}
          handlePickedIdea={handlePickedIdea}
          handlePickedIdeasAll={handlePickedIdeasAll}
          selectedAll={selectedAll}
          handleSortChange={handleSortChangeIdeas}
          sort={sortIdeas}
        />
      )}
    </>
  );
};

export default Tabs;
